/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  wMedium, primaryFont, secondaryFont, primaryColor, maxWidth,
  retina, favouriteArticleColor, whiteColor, greyColor,
  maxMobile,
  maxTablet,
  minStandardScreen,
  minExtraLargeScreen,
  greyColorSecondary,
  creator, SecondaryColor
} from 'Utils/utilsStyle';
import setImageSize, { isGuest, valueToObject } from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectLoading, selectArticle,
  selectSimilarArticleDetail, selectSimilarArticleDetailLoading, selectSimilarArticleTwo,
  selectArticleSummary,
  selectSimilarArticleSummary,
  selectArticleSummaryLoading,
  selectSimilarArticleSummaryLoading,
  selectArticleSummaryLoaded,
  selectSimilarArticleSummaryLoaded,
  selectArticleInsightsExplored,
} from 'Selector/ArticleSector';
import { ArticleExtraInfoConcept, Alert, Article } from 'Types/ArticleTypes';
import SocialShareIcons from 'Components/share/SocialShareIcons';
import { Divider, Popover } from 'antd';
import { actions as favouriteArticleActions } from 'Slice/FavoriteArticlesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import HTMLReactParser from 'html-react-parser';
import classNames from 'classnames';
import { translateSkipAreas } from 'Utils/Constants';
import SkeletonCustom from '../skeleton/SkeletonCustom';
import LightBulb from '../assets/svgIcons/LightBulb';
import SimilarArticle from '../assets/svgIcons/SimilarArticle';
import ArticleInfoConcepts from './ArticleInfoConcepts';
import ArticleInfoSimilarConcept from './ArticleInfoSimilarConcept';
import ArticleSummaryBlock from './ArticleSummaryBlock';
import ArticleDrawerHeadingSkeleton from '../skeleton/ArticleDrawerHeadingSkeleton';
import ArticleDrawerParagraphSkeleton from '../skeleton/ArticleDrawerParagraphSkeleton';
import ShareArticleStrokeIcon from '../assets/svgIcons/ShareArticleStrokeIcon';
import { selectServiceLinePermission } from '../../../Selector/GlobalSearchContentSelector';
import { useLocation } from 'react-router-dom';
import { selectKPMGFlag } from '../../../Selector/GlobalSearchContentSelector';
import { selectSLArticleAlerts } from '../../../Selector/ServiceLinesSelector'
import SingleFavoriteIcon from '../assets/svgIcons/SingleFavoriteIcon';
import ChatbotArticleInsightIcon from '../assets/svgIcons/ChatbotArticleInsightIcon';
import PromotionIcon from '../assets/svgIcons/Promotionicon';

const defaultProps = {
  articleId: 0,
  title: '',
  domain: '',
  dateTimeStamp: '',
  summary: '',
  image: '',
  url: '',
  alertId: 0,
  companyName: '',
  spotlight: false,
  articleAlert: [],
  isSimilarArticle: false,
  similarArticles: [],
  similarArticlesCount: 0,
  articleDetailLoading: false,
  showInsights: false,
};

type Props = {
  articleId?: number;
  title?: string;
  domain?: string;
  dateTimeStamp?: string;
  summary?: string;
  image?: string;
  url?: string
  alertId?: number
  companyName?: string
  spotlight?: boolean
  articleAlert?: Alert[]
  isSimilarArticle?: boolean
  similarArticles?: Article[]
  similarArticlesCount?: number
  articleDetailLoading?: boolean
  onToggleInsights?: () => void
  showInsights?: boolean
};
const StyledWrapper = styled.div`
  .article-title{
    font-family: ${secondaryFont};
    font-size: 38px;
    line-height: 47px;
    color: #000000;
    font-weight: ${wMedium};
    letter-spacing: -0.79px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 27px;
      line-height: 32px;
    }
  }
  .tag-div{
    position: relative;
    &.withOutImage {
      span {
        top: 10px;
        left: 0px;
        right: unset;
      }
      ~ {
        .article-details {
          div {
            margin-top: 0px;
          }
        }
      }
    }
  }
  .article-image{
    width: 100%;
    margin-bottom: 16px;
    margin-top: 16px;
    max-height:193px;
  }
  .article-details{
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.4px;
    color: #0D0D0D;
    white-space: break-spaces;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
      line-height: 16px;
    }
  }
  .article-metadata{
    margin-top: 8px;
    display: flex;
    overflow: hidden;
    .separator {
      padding: 0px 0px 0px 8px;
    }
    &.sharePopoverWrapper{
    .shareBtnAndFavoritesIcon{
      display: flex;
      align-items: center;
      .share-btn{
        display: flex;
        align-items: center;
        margin-bottom: -2px;
      }
      .favorite-icon{
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 1px;
        svg{
          width: 16px;
          height: 15px;
          margin: 0; 
          padding: 0;
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 14px !important;
            width: 14px !important;
          }
          @media all and (max-width: ${maxTablet}) {
            height: 12px !important;
            width: 12px !important;
          }
        }
        .skeleton-box{
          margin-top: 0;
        }
      }
    }
  }
  }
  .separator {
    border-left: 1.5px solid #CFCFCF;
    padding: 0px 5px;
    margin: 0px 5px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 0px 0px;
      margin: 0px 3px;
    }
  }
  .source{
    color: ${greyColorSecondary};
    text-align: center;
    font-family: ${primaryFont};
    font-size: 12px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media all and (min-width: ${minExtraLargeScreen}) {
      font-size: 14px;
    }
    @media all and (${retina}) {
      font-size: 10px;
    }
    @media all and (max-width: ${minStandardScreen}){
      font-size: 10px;
      line-height: 16px;
    }
    @media all and (max-width: ${maxTablet}){
      font-size: 8px;
      line-height: 12.793px;
    }
    @media all and (max-width: ${maxMobile}){
      font-size: 10px;
      line-height: 12.793px;
    }
  }
  .article-timestamp{
    overflow: visible;
  }
  .article-company{
    color: ${creator};
    .separator {
      margin: 0px;
    }
  }
  .source{
    color: ${greyColorSecondary};
    text-align: center;
    font-family: ${primaryFont};
    font-size: 12px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media all and (min-width: ${minExtraLargeScreen}) {
      font-size: 14px;
    }
    @media all and (${retina}) {
      font-size: 10px;
    }
    @media all and (max-width: ${minStandardScreen}){
      font-size: 10px;
      line-height: 16px;
    }
  }
  .article-timestamp{
    overflow: visible;
  }
  .article-company{
    color: ${creator};
    .separator {
      margin: 0px;
    }
  }
  .tabs-item {
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 5px 8px;
      margin-right: 8px;
      white-space: nowrap;
    }
    svg{
      vertical-align: middle;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 12px;
        height: 12px;
      }
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &.article-insights-button {
      display: flex;
      align-items: center;
      gap: 6px;
      .article-insight-chatbot{
        position: relative;
        bottom: 2px;
        width: 20px;
        height: 21px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          width: 21px;
          height: 22px;
        }
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 18px;
          height: 19px;
        }
        @media all and (max-width: ${minStandardScreen}) {
          width: 14px;
          height: 15px;
        }
        svg{
          height: 100%;
          width: 100%;
          padding-bottom: 2px;
        }
      }
    }
  }
  .insight-section {
    display: flex;
    align-items: center;
    .insights-promotion-icon {
      position: absolute;
      cursor: pointer;
      bottom: 20px;
      right: -3px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        bottom: 12px;
        right: -7px;
        svg{
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  .entities-margin{
    margin-top: 29px;
    padding-top: 11px;
    padding-bottom:25px;
  }
  .concepts-margin{
    &.noMarginTop {
      margin-top: 0px;
    }
    margin-top: 29px;
  }
  .line-width{
    width: 80%;
    margin-bottom: 24px;
  }
  .tabs-article-drawer-div {
    &.fullTab {
      .article-tab {
        width: 100%;
        &:last-child {
          border-radius: 8px;
        }
      }
    }
    display: flex;
    align-items: center;
    width: 100%;
    .article-tab {
      &.activeTab {
        background: #DEF6E6;
        color: ${primaryColor};
        svg {
          path {
            fill: ${primaryColor};
          }
        }
      }
      &:first-child {
        border-radius: 8px 0px 0px 8px;
      }
      &:last-child {
        border-radius: 0px 8px 8px 0px;
      }
      svg {
        margin-right: 5px;
        width: 19px;
        min-width: 19px;
        height: 19px;
        path {
          fill: ${greyColor};
        }
      }
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 38px;
      width: 50%;
      color: ${greyColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 20px;
      letter-spacing: -0.4px;
      background: #fff;
      border: 1px solid #DADADA;
      padding: 10px 14px 8px 14px;
      cursor: pointer;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 14px;
        line-height: 18px;
        padding: 8px 12px 6px 12px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 13px;
      }
    }
  }
  .button-section{
    align-items: center;
    position: relative;
    margin-top: 35px;
    margin-bottom:29px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 20px;
      margin-bottom:15px;
      padding-right: 0px;
      align-items: center;
    }
    .shareFavDiv {
      .share-btn {
        position: relative;
        top: -6px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          top: 0px;
        }
      }
      .favorite-icon{
        .skeleton-box {
          margin-top: 10px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-top: 0px
        }
        }
      }
    }
    .padded-entities{
      padding-right: 62px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        padding-right: 30px;
      }
    }
    .entities_Block{
      column-gap: 10px;
      row-gap: 10px;
    }
    .article-viewer-btn{
      display: flex;
      align-items: center;
    }
  }
`;

const Image = styled.img`
  height: 193;
  width: 468px;
  border-radius: 8px;
  background-position: center;
  background-size: cover;
`;

const ContentWrapper = styled.div``;
const ArticleTag = styled.span <{ tagColor: string }>`
&.secondaryColorText {
  color: ${SecondaryColor};
}
 font-size: 14px;
 padding: 0px 10px;
 color: #fff;
 border: 1px solid #fff;
 font-weight: ${wMedium};
 font-family: ${primaryFont};
 border-radius: 12px;
 background-color: ${(props) => props.tagColor};
 line-height: 18px;
 letter-spacing: -0.29px;
 position: absolute;
 right: 15px;
 top: 28px;
 z-index: 1;
`;

export const formatConcepts = (concepts: ArticleExtraInfoConcept[]) => concepts?.map(
  ({ name, relevance }: ArticleExtraInfoConcept) => ({
    name,
    y: Math.floor(Number(relevance) * 100),
  }),
);

const ArticleInfo = function ArticleInfo(props: Props) {
  const similarArticleDetails = useSelector(selectSimilarArticleDetail);
  const articleLoading = useSelector(selectLoading);
  const similarArticleloading = useSelector(selectSimilarArticleDetailLoading);
  const similarArticlesTwo = useSelector(selectSimilarArticleTwo);
  const article = useSelector(selectArticle);
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(false);
  const [conceptTab, setConceptTab] = useState(false);
  const host = window.location.href;
  const serviceLinePermission = useSelector(selectServiceLinePermission);
  const serviceLinePage = window.location.href.includes('/serviceline');
  const KPMGFlag = useSelector(selectKPMGFlag);
  const SLAlerts = useSelector(selectSLArticleAlerts);
  const articleInsightsExplored = useSelector(selectArticleInsightsExplored);

  const toggleTabs = () => {
    setConceptTab(!conceptTab);
  };
  const {
    articleId,
    title,
    domain,
    dateTimeStamp,
    summary,
    image,
    url,
    alertId,
    companyName,
    spotlight,
    articleAlert,
    isSimilarArticle,
    similarArticles,
    similarArticlesCount,
    articleDetailLoading,
    showInsights,
    onToggleInsights,
  } = props;

  const loading = isSimilarArticle ? similarArticleloading : articleLoading;
  const firstArticleSummary = useSelector(selectArticleSummary);
  const similarticleSummary = useSelector(selectSimilarArticleSummary);
  const fisrtLoading = useSelector(selectArticleSummaryLoading);
  const similarLoading = useSelector(selectSimilarArticleSummaryLoading);
  const fisrtLoaded = useSelector(selectArticleSummaryLoaded);
  const similarLoaded = useSelector(selectSimilarArticleSummaryLoaded);
  const summaryLoaded = isSimilarArticle ? similarLoaded : fisrtLoaded;
  const summaryLoading = isSimilarArticle ? similarLoading : fisrtLoading;
  const articleSummary = isSimilarArticle ? similarticleSummary : firstArticleSummary;
  const showConceptsTab = article?.articleExtraInfo?.concepts.length || article?.articleExtraInfo?.entities.length;
  const showBlipIcon = article?.blip === 1 ? !!articleInsightsExplored : !!article?.blip;

  const ServiceLineAlerts = (KPMGFlag && serviceLinePage) && SLAlerts[articleId ?? 0]


  useEffect(() => {
    if (serviceLinePermission && serviceLinePage) {
      setConceptTab(true);
    }
  }, [serviceLinePage]);


  useEffect(() => {
    if (serviceLinePermission && serviceLinePage) {
      setConceptTab(true);
    }
  }, [serviceLinePage]);

  const content = (
    <ContentWrapper className="sharingPopoverContentWrapper">
      <h6 className="heading-popover">QuickShare to:</h6>
      <SocialShareIcons
        articleid={articleId || ''}
        title={title || article?.title || ''}
        img={image || article?.image || ''}
        domain={domain || article?.domain || ''}
        entity="article"
        alertId={alertId || (article?.alerts && article?.alerts[0]?.alertId) || 0}
        url={url || article?.url}
        spotlight={spotlight}
        summary={articleSummary}
        summaryLoading={summaryLoading}
        summaryLoaded={summaryLoaded}
      />
    </ContentWrapper>
  );

  const addToFavorite = (id: number) => {
    const targetArticle = isSimilarArticle ? similarArticleDetails : article;
    if (targetArticle) {
      const data = {
        articleId: id,
        favoriteFlag: targetArticle.isFavorite ? 0 : 1,
        isSimilarArticle: !!isSimilarArticle,
        isSimilarArticleTwo: similarArticlesTwo.length > 0,
        isDetail: true,
      };
      dispatch(favouriteArticleActions.addToFavorite(data));
    }
  };

  const handleOpenChange = (open: boolean) => {
    if (open) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('article_share_intent', 0, {
          host,
        }),
      ));
    }
  };

  const handleWebsiteClick = () => {
    window.open(url || article?.url);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('article_weblink_clicked', 0, {
        host,
      }),
    ));
  };

  const Content = () => (
    <div className="insights-popover-content">
      Explore New Feature by clicking on it
    </div>
  );

  const handleShowMoreClick = () => {
    if (!showAll) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('article_showMore_clicked', 0, {
          host,
        }),
      ));
    }
    setShowAll(!showAll);
  };

  return (
    <StyledWrapper>
      {
        articleDetailLoading ? (
          <ArticleDrawerHeadingSkeleton />
        ) : (
          <span className="article-title text-truncate-four-line">{title || article?.title}</span>
        )
      }
      {
        articleDetailLoading ? (
          <SkeletonCustom
            width="100%"
            height="194px"
            margin="0px 0px 12px 0px"
            marginSm="0px 0px 12px 0px"
          />
        ) : (
          <div className={classNames('tag-div', { withOutImage: !image })}>
            {image
              ? (
                <Image className="article-image" src={image ? setImageSize(image, 468, 193, articleId || 0) : setImageSize(article?.image || '', 468, 193, articleId || 0)} alt="article-place" />) : null}
            {!KPMGFlag && articleAlert && articleAlert?.length && !loading ? (
              <ArticleTag
                tagColor={articleAlert[0]?.color}
                className={classNames({ secondaryColorText: ServiceLineAlerts })}
              >
                {articleAlert[0]?.alert}
              </ArticleTag>
            ) : null}
          </div>
        )
      }
      <ArticleSummaryBlock
        isSimilarArticle={isSimilarArticle as boolean}
        showAll={showAll}
        withOutImage={!image || !article?.image}
        showInsights={showInsights ?? false}
        toggleInsights={onToggleInsights || (() => { })}
      />
      {
        articleDetailLoading ? (
          <ArticleDrawerParagraphSkeleton />
        ) : (
          <span className={`article-details mt-c-20 ${showAll ? '' : 'text-truncate-four-line'}`}>{article?.summary?.length && !isSimilarArticle ? HTMLReactParser(article?.summary || '') : HTMLReactParser(summary || '')}</span>
        )
      }
      <div className="article-metadata sharePopoverWrapper">
        {!isGuest() && (
          <div className={classNames('shareBtnAndFavoritesIcon', { shareFavDiv: loading })}>
            {articleId !== undefined && articleId > 0 && (
              <span
                className="favorite-icon"
                onClick={() => addToFavorite(articleId)}
                onKeyPress={() => addToFavorite(articleId)}
                tabIndex={0}
                role="button"
                aria-label="Faviourite"
              >
                {!loading ? (
                  isSimilarArticle ? (
                    similarArticleDetails?.isFavorite ? (
                      <SingleFavoriteIcon
                        strokeColor={favouriteArticleColor}
                        fillColor={favouriteArticleColor}
                      />
                    ) : (
                      <SingleFavoriteIcon
                        strokeColor={greyColor}
                      />
                    )
                  ) : (
                    article?.isFavorite ? (
                      <SingleFavoriteIcon
                        strokeColor={favouriteArticleColor}
                        fillColor={favouriteArticleColor}
                      />
                    ) : (
                      <SingleFavoriteIcon
                        strokeColor={greyColor}
                      />
                    )
                  )
                ) : (
                  <SkeletonCustom
                    width="25px"
                    height="25px"
                    diameter="15px"
                    margin="6px 0px 0px 5px"
                    marginSm="0px 0px 0px 5px"
                  />
                )}
              </span>
            )}
            <div className="share-btn separator">
              <Popover
                placement="right"
                onOpenChange={handleOpenChange}
                content={content}
                trigger="click"
                getPopupContainer={(e: HTMLElement) => e}
                className="popover-sharing popoverSharingCustom"
                arrow={false}
              >
                <span
                  className="c-pointer"
                  aria-hidden="true"
                >
                  <ShareArticleStrokeIcon color={greyColor} />
                </span>
              </Popover>
            </div>
          </div>
        )}
        <span className="source article-timestamp separator">{dateTimeStamp || article?.dateTimeStamp}</span>
        <span className="source article-source separator">{domain || article?.domain}</span>
        {companyName !== '' ? <span className="source article-company"><span className="separator">{companyName || article?.companyName}</span></span> : null}
      </div>
      <div className="button-section d-flex justify-content-between sharePopoverWrapper">
        <div className="article-viewer-btn">
          {loading ? (
            <SkeletonCustom
              width="50px"
              height="25px"
              margin="0px 5px 0px 0px"
              marginSm="0px 5px 0px 0px"
            />
          )
            : summary !== '' || article?.summary !== '' ? (
              <span
                className="tabs-item c-pointer"
                onClick={handleShowMoreClick}
                onKeyPress={handleShowMoreClick}
                tabIndex={0}
                role="button"
                aria-label={showAll ? 'Show Less' : 'Show More'}
              >
                {showAll ? 'Show Less' : 'Show More'}
              </span>
            ) : null}
          <span
            onClick={handleWebsiteClick}
            onKeyPress={handleWebsiteClick}
            tabIndex={0}
            role="button"
            className="tabs-item c-pointer"
            aria-label="Visit website"
          >
            Visit website
          </span>
        </div>
        {!isSimilarArticle &&
          <div className="insight-section">
            <span
              role="button"
              className={`article-insights-button tabs-item c-pointer ${(fisrtLoading || showInsights) && 'disabled'}`}
              tabIndex={0}
              onClick={onToggleInsights || (() => { })}
              onKeyPress={onToggleInsights || (() => { })}
            >
              <ChatbotArticleInsightIcon className="article-insight-chatbot" />
              Gilroy Insights
            </span>
            <Popover
              placement="bottom"
              content={<Content />}
              getPopupContainer={(e: HTMLElement) => e}
              arrow={false}
            >
              <span className='insights-promotion-icon'>{!!showBlipIcon && <PromotionIcon />}</span>
            </Popover>

          </div>
        }
      </div>
      {!loading ? <div className={classNames('tabs-article-drawer-div', {
        fullTab: similarArticles?.length === 0 || (serviceLinePermission && serviceLinePage)
      })}>
        {serviceLinePermission && serviceLinePage ? null :
          <>
            {similarArticles?.length !== 0 ? (
              <span
                tabIndex={0}
                role="button"
                onClick={toggleTabs}
                onKeyPress={toggleTabs}
                className={classNames('article-tab text-truncate', { activeTab: !conceptTab })}
              >
                <SimilarArticle />
                {' '}
                {' '}
                Similar
                {' '}
                {(similarArticlesCount || 0) > 1 ? 'Articles' : 'Article'}
                {' '}
                {' '}
                {`(${similarArticlesCount || 0})`}
              </span>
            ) : null}
          </>
        }

        {showConceptsTab ? <span
          tabIndex={0}
          role="button"
          onClick={() => toggleTabs()}
          onKeyPress={() => toggleTabs()}
          className={classNames('article-tab text-truncate', { activeTab: conceptTab || similarArticles?.length === 0 })}
        >
          <LightBulb />
          {' '}
          Concepts Mentioned
        </span> : null}
      </div> : null}
      {
        conceptTab || similarArticles?.length === 0 ? (
          <ArticleInfoConcepts
            noMargin={similarArticles?.length === 0}
            article={similarArticleDetails?.articleId ? similarArticleDetails : article}
            isSimilarArticle={isSimilarArticle || false}
          />
        ) : (
          <ArticleInfoSimilarConcept
            articleId={articleId}
            similarArticles={similarArticles as Article[]}
            similarArticlesCount={similarArticlesCount}
            isSimilarArticle={isSimilarArticle || false}
          />
        )
      }
    </StyledWrapper>
  );
};

ArticleInfo.defaultProps = defaultProps;
export default ArticleInfo;